import $ from "jquery";
import Swiper from "swiper/bundle";

export const RoleSelection = function () {
	if (!($(".role-selection").length > 0)) return false;

	const $elms = {
		submit: $(".js-role-selection-submit"),
		moveToGoal: $(".js-move-to-goal"),
		moveBack: $(".js-move-back"),
		roleBtnText: $(".js-role-btn-text"),
		layoutSelector: $(".role-card__user"),
		fillDark: $(".filldark"),
		fillTransparent: $(".filltransparent"),
		roleInfoBtn: $(".js-role"),
		roleCardPopup: $(".js-role-card-popup"),
		roleCardPopupClose: $(".js-role-card-popup-close"),
		// expandContent: $(".js-expand-content"),
		// expandContentBox: $(".js-expand-content-box"),
		customGoalTextarea: $(".role-card__textarea"),
	};

	const gradientColorDark = $elms.layoutSelector.attr(
		"data-gradient-color-dark",
	);
	const gradientColorLight = $elms.layoutSelector.attr(
		"data-gradient-color-light",
	);

	if (gradientColorDark && gradientColorLight) {
		$elms.fillDark.css("fill", gradientColorDark);
		$elms.fillTransparent.css("fill", gradientColorLight);
	}

	let mainSwiper; // Store the main swiper instance

	$elms.moveBack.on("click", function () {
		$(".role-selection.standard-layout").removeClass("is-open-goal");
	});

	$elms.moveToGoal.on("click", function () {
		if (mainSwiper && mainSwiper.activeIndex !== -1) {
			const activeSlide = mainSwiper.slides[mainSwiper.activeIndex];
			const roleColor = $(activeSlide).attr("data-role-color") || "#f17f3c";

			$(".open-goal .role-card__colorValue").css("background-color", roleColor);
			$(".open-goal .role-card__user-avatar").css("background-color", roleColor);
		}
		
		$(".role-selection.standard-layout").addClass("is-open-goal");
	});

	const changeButtonText = () => {
		const activeSlide = mainSwiper.slides[mainSwiper.activeIndex];
		const roleName = $(activeSlide).attr("data-role-name");
		const roleColor = $(activeSlide).attr("data-role-color");

		if (roleColor) {
			$elms.submit.css("background-color", roleColor);
			$elms.moveToGoal.css("background-color", roleColor);
		} else {
			$elms.submit.css("background-color", "#f17f3c");
			$elms.moveToGoal.css("background-color", "#f17f3c");
		}

		$elms.roleBtnText.text(roleName ? roleName : "Role");
	};

	const initSwiper = () => {
		if (typeof Swiper === "undefined") {
			console.error("Swiper library is not loaded");
			return;
		}

		const navElement = document.querySelector(".nav-swiper");
		const mainElement = document.querySelector(".main-swiper");

		if (!navElement || !mainElement) {
			console.error("Required swiper elements not found");
			return;
		}

		const userRoleId = $(".role-selection").attr("data-user-role-id");
		let initialSlideIndex = 2;

		if (userRoleId) {
			const slides = document.querySelectorAll(".main-swiper .swiper-slide");
			slides.forEach((slide, index) => {
				if ($(slide).attr("data-role-id") === userRoleId) {
					initialSlideIndex = index;
				}
			});
		}

		const navSwiper = new Swiper(".nav-swiper", {
			spaceBetween: 10,
			slidesPerView: 5,
			initialSlide: initialSlideIndex,
			centeredSlides: true,
			freeMode: true,
			watchSlidesProgress: true,
			allowTouchMove: false,
		});

		mainSwiper = new Swiper(".main-swiper", {
			loop: true,
			spaceBetween: 10,
			initialSlide: initialSlideIndex,
			thumbs: {
				swiper: navSwiper,
			},
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
		});

		changeButtonText();
		mainSwiper.on("slideChange", changeButtonText);
	};

	$elms.submit.on("click", function (e) {
		e.preventDefault();

		if ($elms.submit.hasClass("is-loading")) {
			return;
		}

		const isInCustomGoalForm = $(".role-selection.standard-layout").hasClass("is-open-goal");

		if (isInCustomGoalForm) {
			const customGoal = $elms.customGoalTextarea.val().trim();

			// if (!customGoal) {
			// 	alert(window.CFG.strings.customGoalRequired || "Please enter your personal learning goal.");
			// 	return;
			// }

			$elms.submit.addClass("is-loading");

			const userHasRole = $(".role-selection").attr("data-user-has-role") === "true";

			if (userHasRole) {
				$.ajax({
					url: window.CFG.ajaxUrl,
					type: "POST",
					data: {
						action: "save-custom-goal",
						nonce: window.CFG.nonce,
						custom_goal: customGoal,
					},
					success: function (goalResponse) {
						if (!goalResponse.success) {
							console.error(goalResponse.data.message || "Failed to save custom goal");
							alert(goalResponse.data.message || "Failed to save custom goal");
						} else {
							window.location.reload();
						}
					},
					error: function (error) {
						console.error(error);
						alert("An error occurred while saving your custom goal. Please try again.");
					},
					complete: function () {
						$elms.submit.removeClass("is-loading");
					},
				});
			} else {
				if (mainSwiper.activeIndex === -1) {
					console.error("No active slide found");
					$elms.submit.removeClass("is-loading");
					return;
				}

				const activeSlideIndex = mainSwiper.activeIndex;
				const activeSlide = mainSwiper.slides[activeSlideIndex];
				const roleId = $(activeSlide).attr("data-role-id");

				$.ajax({
					url: window.CFG.ajaxUrl,
					type: "POST",
					data: {
						action: "select-role",
						nonce: window.CFG.nonce,
						role_id: roleId,
					},
					success: function (roleResponse) {
						if (!roleResponse.success) {
							console.error(roleResponse.data.message || "Failed to save role");
							alert(roleResponse.data.message || "Failed to save role");
							$elms.submit.removeClass("is-loading");
							return;
						}

						$.ajax({
							url: window.CFG.ajaxUrl,
							type: "POST",
							data: {
								action: "save-custom-goal",
								nonce: window.CFG.nonce,
								custom_goal: customGoal,
							},
							success: function (goalResponse) {
								if (!goalResponse.success) {
									console.error(goalResponse.data.message || "Failed to save custom goal");
									alert(goalResponse.data.message || "Failed to save custom goal");
								} else {
									window.location.href = goalResponse.data.redirect;
								}
							},
							error: function (error) {
								console.error(error);
								alert("An error occurred while saving your custom goal. Please try again.");
							},
							complete: function () {
								$elms.submit.removeClass("is-loading");
							},
						});
					},
					error: function (error) {
						console.error(error);
						alert("An error occurred while saving your role. Please try again.");
						$elms.submit.removeClass("is-loading");
					},
				});
			}
		}
	});

	// Read more / Less expand-collapse - commented out so full role description is always shown
	// $elms.expandContentBox.each(function () {
	// 	const $this = $(this);
	// 	const $parent = $this.parent();
	// 	const thisHeight = $this.outerHeight();
	// 	const parentHeight = $parent.outerHeight();
	//
	// 	if (thisHeight > parentHeight) {
	// 		$parent.addClass("is-more");
	// 	}
	// });
	//
	// $elms.expandContent.on("click", function () {
	// 	const hasOpened = $(this).hasClass("is-expanded");
	// 	const isOpen = !hasOpened;
	//
	// 	$(this).toggleClass("is-expanded", isOpen);
	// });

	$elms.roleInfoBtn.on("click", function () {
		const learningGoalId = $(this).attr("data-learning-goal-id");
		const learningGoalColor = $(this).attr("data-color");
		$elms.roleCardPopup.removeClass("is-active");
		$elms.roleCardPopup
			.filter(`[data-learning-goal-id="${learningGoalId}"]`)
			.css("background-color", learningGoalColor)
			.addClass("is-active");
	});

	$elms.roleCardPopupClose.on("click", function () {
		$elms.roleCardPopup.removeClass("is-active");
	});

	$(document).on("click", function (e) {
		const activePopup = $elms.roleCardPopup.filter(".is-active");
		if (activePopup.length > 0) {
			if (
				!activePopup.is(e.target) &&
				activePopup.has(e.target).length === 0 &&
				!$(e.target).closest(".js-role").length
			) {
				$elms.roleCardPopup.removeClass("is-active");
			}
		}
	});

	initSwiper();
};
